/** @format */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'uriDecode',
})
export class UriDecodePipe implements PipeTransform {
  transform(value: string): string {
    return decodeURIComponent(value);
  }
}
